import { redirectToCallback } from '@features/auth/lib/redirectToCallback';
import { useRouter } from 'next/router';
import { useMutation, useQueryClient } from 'react-query';
import type { AxiosResponse } from 'axios';
import { axiosInstance } from '@shared/lib/axios';
import type { TAxiosError } from '@shared/lib';
import { MUTATIONS_INFO, QUERIES_INFO, ROUTES } from '@shared/lib';
export const useLogout = (token?: string) => {
  const router = useRouter();
  const body = token ? {
    token
  } : undefined;
  const queryClient = useQueryClient();
  return useMutation<AxiosResponse<{
    jwtCallbackUrl: string;
    idpTransportToken: string;
  } | null>, TAxiosError>(() => axiosInstance.post(MUTATIONS_INFO.logout, body), {
    onSuccess: async ({
      data
    }) => {
      if (data) {
        const {
          jwtCallbackUrl,
          idpTransportToken
        } = data;
        redirectToCallback({
          jwtCallbackUrl,
          token: idpTransportToken,
          accessToken: idpTransportToken
        });
        return;
      }
      await queryClient.resetQueries(QUERIES_INFO.currentUser.key);
      await router.push(ROUTES.root);
    }
  });
};